import { render, staticRenderFns } from "./AlarmSet.vue?vue&type=template&id=772873c4&scoped=true&"
import script from "./AlarmSet.vue?vue&type=script&lang=js&"
export * from "./AlarmSet.vue?vue&type=script&lang=js&"
import style0 from "./AlarmSet.vue?vue&type=style&index=0&id=772873c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772873c4",
  null
  
)

export default component.exports